import React from "react";
import { IForm } from "../../../../types/form.type";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../../../contexts/alert/AlertProvider";
import { useForm } from "react-hook-form";
import { asyncPostData, asyncPutData } from "../../../../utils/httpRequests";
import ModalForm from "../../modal/ModalForm";
import { Stack, Typography } from "@mui/material";
import TextInput from "../../input/TextInput";
import NumberInput from "../../input/NumberInput";

const schema = yup.object({
  name: yup.string().required("Vui lòng nhập tên tuyến đường"),
  start: yup.string().required("Vui lòng nhập điểm xuất phát"),
  end: yup.string().required("Vui lòng nhập điểm đến"),
});

function FormRoute({
  defaultValues,
  isEdit,
  apiCode,
  open,
  onClose,
  setLoad,
}: IForm) {
  const app = useSelector((state: any) => state.app.data);
  const token = useSelector((state: any) => state.auth.token);
  const { showAlert } = useAlertContext();
  const defaultData: { [key: string]: any } = {
    stt: 0,
    name: "",
    start: "",
    end: "",
    distance: "",
    time: "",
  };
  const originData = defaultValues || defaultData;

  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors },
  } = useForm({
    mode: "onSubmit",
    defaultValues: originData,
    resolver: yupResolver(schema),
  });

  const handleReset = () => {
    reset(originData);
  };

  const generateDataPost = async (values: typeof defaultData) => {
    return values;
  };

  const handleSave = async (values: typeof defaultData) => {
    const dataPost: { [key: string]: any } = await generateDataPost(values);
    let resp = null;
    if (isEdit) {
      resp = await asyncPutData({
        id: dataPost._id,
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    } else {
      resp = await asyncPostData({
        apiCode,
        token,
        idApp: app?._id,
        data: dataPost,
      });
    }
    if (resp.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.message || "Lỗi khi lưu đối tượng",
      });
    } else {
      onClose();
      setLoad?.((prev: number) => prev + 1);
    }
  };

  const onSubmit = handleSubmit(handleSave);

  return (
    <ModalForm
      formWidth="500px"
      formTitle="tuyến đường"
      loading={isSubmitting}
      open={open}
      isEdit={isEdit}
      onClose={onClose}
      onSubmit={onSubmit}
      onReset={handleReset}
    >
      <Stack gap={2}>
        <NumberInput
          label="STT"
          labelWidth="30%"
          name="stt"
          register={register}
        />
        <TextInput
          required
          label="Tên tuyến"
          labelWidth="30%"
          placeholder="Nhập tên tuyến đường"
          name="name"
          register={register}
          errorMessage={errors?.name?.message as string}
        />
        <TextInput
          required
          label="Điểm đi"
          labelWidth="30%"
          placeholder="Nhập điểm xuất phát"
          name="start"
          register={register}
          errorMessage={errors?.start?.message as string}
        />
        <TextInput
          required
          label="Điểm đến"
          labelWidth="30%"
          placeholder="Nhập điểm đến"
          name="end"
          register={register}
          errorMessage={errors?.end?.message as string}
        />
        <NumberInput
          label="Khoảng cách"
          labelWidth="30%"
          placeholder="Nhập khoảng cách đường đi"
          name="distance"
          endAdornment={
            <Typography sx={{ pr: 1, color: "text.secondary" }}>KM</Typography>
          }
          register={register}
        />
        <NumberInput
          label="Số giờ đi"
          labelWidth="30%"
          placeholder="Nhập số giờ đi"
          name="time"
          endAdornment={
            <Typography sx={{ pr: 1, color: "text.secondary" }}>Giờ</Typography>
          }
          register={register}
        />
      </Stack>
    </ModalForm>
  );
}

export default FormRoute;
